/**
 * Liste des champs obligatoires pour une entreprise individuelle
 */
export const EI_REQUIRED_FIELDS = [
  "title",
  "firstName",
  "lastName",
  "citizenshipCountryCode",
  "birthDate",
  "residenceCountryCode",
  "birthCountryCode",
  "activityCode", // Activité
  "personLegalFormCode", // Forme juridique
  "customString1", // Code postal + ville du siège social
  "customString2", // Numéro et rue du siège social
  "customCountryCode1", // Pays du siège social
] as const;

/**
 * Type pour les champs requis d'une entreprise
 */
export type EIRequiredField = (typeof EI_REQUIRED_FIELDS)[number];
